module.exports = __webpack_public_path__ + "static/birdHouse1-5e599070aa577dd2ddea8cb23d301248.jpg";